<template>
  <div class="sso">
    <div
      class="d-flex justify-content-center align-items-center title text-primary"
    >
      單一驗證登入中
    </div>
    <div
      class="d-flex justify-content-center align-items-center title text-primary"
    >
      {{ successMessage }}
    </div>
  </div>
</template>

<script>
import { request } from '@/service';

export default {
    name: 'SingleSignOn',
    data() {
        return {
            successMessage: ''
        };
    },
    async mounted() {
        const srcId = this.$route.query.srcId;
        const productId = this.$route.query.productId;
        const token = this.$route.query.token;
        if (!token) {
            await this.$router.push({ path: '/error/404' });
        } else {
            await this.ssoLogin(token, srcId, productId);
        }
    },
    methods: {
        async ssoLogin(ssoToken, srcId, productId) {
            request({
                method: 'POST',
                api: '/api/share/sso',
                base: false,
                data: {
                    token: ssoToken,
                    srcId: srcId,
                    productId: productId
                },
            })
                .then((res) => {
                    const data = res.data;
                    if (res.status === 200) {
                        this.successMessage = '登入成功';
                        const protocol = window.location.protocol;
                        window.location = `${protocol}` + data;
                    }
                }).catch(error => {
                    this.$notify({
                        group: 'alert',
                        title: '發生錯誤:' + error,
                        type: 'error',
                    });
                });
        },
    },
};
</script>

<style scoped lang="scss">
.sso {
  padding: 15px;
}
</style>
